import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@modules/shared/services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.tokenExpired) {
      console.log('Token expired');
    } else {
      if (this.authService.accessToken) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.authService.accessToken}`,
          },
        });
      }
    }

    return next.handle(request);
  }
}
